import {Box, Container} from "@mui/material";
import React, {useEffect} from "react";
import createAppointmentImage from "../assets/create-appointment.png";
import {AlfyButton} from "../components/AlfyButton";
import {useNavigate} from "react-router-dom";
import {useNavbar} from "../states/common/client";

export default function DefaultPage() {
    const { setNavbarTitle, setNavbarBackButton, reset } = useNavbar()
    const navigate = useNavigate();

    useEffect(() => {
        reset()
        setNavbarTitle("약속잡기")
        setNavbarBackButton(false)
    }, [])

    return (
        <Container className={"fullscreen"} sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        }}>
            <Box>
                <Box height={"30px"}/>
                <span className={"primary-title-text"}>아래 버튼을 누르고<br/>편하게 약속을 잡아보세요</span>
                <Box height={"8px"}/>
                <span className={"description-text"}>약속을 만들고 친구들에게 공유해 투표받을 수 있어요</span>
            </Box>
            <Box textAlign={'center'}>
                <img src={createAppointmentImage} alt="create-appointment"/>
            </Box>
            <Box>
                <Box paddingY={"20px"}>
                    <AlfyButton text={"약속 만들기"} onClick={() => navigate('/appointments/create')}/>
                </Box>
            </Box>
        </Container>
    )
}